// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"110130fc","395":"6efdf97d","669":"94e5478b","746":"12895a66"}[chunkId] + ".chunk.js";
};